import React from 'react'
import { motion } from 'framer-motion'
import styles from './LbGsHero.module.css'
import { Link } from 'react-router'

const LbGsHero = ({ onNext }) => {
    return (
        <motion.div
            className={styles.gsHeroContainer}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.6 }}
        >
            <div className={styles.gsHeroContent}>
                <h1>Welcome to LeadBridge Setup</h1>
                <p>Seamlessly connect your website forms with your CRM. Let’s get you onboarded in just a few quick steps.</p>
            </div>

            <div className={styles.stickyNav}>
                <Link to={`/leadbridge/get-started/create-form`} className={styles.primaryBtn} onClick={onNext}>Start Setup ➜</Link>
            </div>
        </motion.div>
    )
}

export default LbGsHero
